/**
* @name APP adminPanel
* @description
* # name controller --> studentsCreateController
* # As Controller --> studentsCreate
* brief comment controller the view for the list Student active admin-Panel
*/

export default class studentsCreateController {
	constructor($scope,ngNotify,UserInfoConstant,studentsServices,$state) {
        this.ngNotify = ngNotify;
        this.$state = $state;
        this.$scope = $scope;
        this.services = studentsServices.services
		this.esValido = 0

        this.student  = { 
            name : null,
            email : null,
            picture : require("../../../../images/no_user.jpg"),
            lastname : null,
			nameAttorney: null,
			gender: null,
			level: null,
            status : true,
            ngNotify : ngNotify,
            services : studentsServices.services,
            afterSave : true
        }

		this.$scope.UserInfoConstant = UserInfoConstant;
		this.$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
			if (details !== undefined) {
				this.user = details.user.id;
				this.user_id = details.user.id;
				this.conceptId = details.user.conceptId
				this.init()
			}
		})
	}

	init(){
		const params = {
			concept_id: this.conceptId
		}

		this.getGenders()
	}

	getGenders(){
		this.genders = [
			{
				id_code: 1,
				ds_name: 'femenino'
			},
			{
				id_code: 2,
				ds_name: 'masculino'
			}
		]
    }

	beforeSave(){
		if(this.student.name === null) {
			this.ngNotify.set('Indique nombre','warn')
			return
		}

		if(this.student.lastname === null) {
			this.ngNotify.set('Indique apellidos','warn')
			return
		}

		if(this.student.rut === null && this.esValido === 0) {
			this.ngNotify.set('Rut inválido','warn')
			return
		}

		if(this.student.email === null) {
			this.ngNotify.set('Indique email','warn')
			return
		}

		if(this.student.nameAttorney === null) {
			this.ngNotify.set('Indique nombre apoderado','warn')
			return
		}
		
		if(this.student.gender === null) {
			this.ngNotify.set('Indique género','warn')
			return
		}

		this.$scope.isDisabled = true;
		let params  = { 
			name   : this.student.name,
			ds_last_name   : this.student.lastname,
			ds_rut   : this.student.rut,
			ds_name_attorney: this.student.nameAttorney,
			user_id : this.user_id,
			concept_id: this.conceptId,
			gender_id: this.student.gender,
			ds_mail: this.student.email
		}

		this.saveStudent(params)
	}

	validarRut(rut) {
		if(rut === undefined || rut.length < 9 || !rut.includes('-')) { 
			this.ngNotify.set('Ingrese Rut','warn')
			return
		}
		rut = rut.toUpperCase()
		rut = rut.trim().split('-')

		const rutString = this.validarString(rut[0])
		const dvr = this.validarString(rut[1])
		let largo = rutString.length;
		let factor = 2;
		let contador = 0;
		let caracter = 0;
		let suma = 0;
		let cdv = '123456789K0';

		while (largo !== 0) {
			caracter = parseInt(rutString.charAt(largo - 1), 10);
			suma = suma + (caracter * factor);
			largo = largo - 1;
			factor = factor + 1;
			if (factor === 8) {
				factor = 2;
			}
		}

		let dv = 11 - (suma % 11)
		this.esValido = (cdv.charAt(dv - 1) === dvr) ? 1 : 0

		if(this.esValido) {
			this.ngNotify.set('Rut válido','success')
		} else {
			this.ngNotify.set('Rut inválido','warn')
		}

		return
	}

	validarString(cadena) {
		let resultado = cadena.trim()
		resultado = resultado.replace(/[^a-zA-Z0-9]/g, '')
	  
		return resultado;
	}
			
	saveStudent(params){
		this.$scope.studentsCreate.student.isDisabled=true
		this.services.saveStudents(params).$promise.then((dataReturn) => {
			if(dataReturn.status == 0){
				this.ngNotify.set('Se ha creado el estudiante correctamente','success');
				this.$state.go("app.students");
			}else{
				this.ngNotify.set('Error , con el servicio','error');
				this.$scope.isDisabled = false;
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
			this.$scope.isDisabled = false;
		})
	}
}

studentsCreateController.$inject=['$scope','ngNotify','UserInfoConstant','studentsServices', '$state']



// WEBPACK FOOTER //
// ./src/app/admin-panel/students/create/studentsCreateController.js